import { useNavigate } from "react-router-dom";
import { UseFormReturn } from "react-hook-form";
import { useProgram } from "@pages/Program/utils/useProgram";
import { ProgramPayload } from "@shared/interfaces/ProgramFiles";
import { useSidebar } from "@services/SidebarContext";

interface SaveProgramOptions {
  programId?: string;
}

const useHandleSaveProgram = (
  options: SaveProgramOptions,
  methods: UseFormReturn<ProgramPayload, any, any>
) => {
  const navigate = useNavigate();
  const { saveProgram } = useProgram();
  const { refreshPrograms } = useSidebar();

  const handleSaveProgram = async (payload: ProgramPayload) => {
    try {
      const budget = payload.budget
        ? parseFloat(payload.budget.replace(/,/g, ""))
        : 0;

      const budget_spent = payload.budget_spent
        ? parseFloat(payload.budget_spent.replace(/,/g, ""))
        : 0;

      const payloadUpdated = {
        ...payload,
        budget: budget.toString(),
        budget_spent: budget_spent.toString(),
      };

      const program = await saveProgram(payloadUpdated, {
        programId: options.programId,
      });

      refreshPrograms();
      methods.reset(methods.getValues());
      setTimeout(() => {
        if (options.programId) navigate(`/programs`);
        else navigate(`/program/${program.id}`);
      }, 500);
    } catch (error) {
      console.error("Error saving program:", error);
    }
  };

  return handleSaveProgram;
};

export default useHandleSaveProgram;
